import { render } from "./UsuariosList.vue?vue&type=template&id=248b3332"
import script from "./UsuariosList.vue?vue&type=script&lang=js"
export * from "./UsuariosList.vue?vue&type=script&lang=js"

import "./UsuariosList.vue?vue&type=style&index=0&id=248b3332&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__